import { TOAST_TYPE } from "../../constants";
import { CUSTOMER_NOTIFICATIONS } from "../../constants/customerApiRoutes";
import { GetApiPaginationType } from "../../types";
import { showToastMessage } from "../../utils";
import API from "../axios";

export const getAllNotifications = async (
  handleData: CallableFunction,
  functionally: GetApiPaginationType = {
    searchQuery: "",
    limit: 10,
    page: 1,
    sortOrder: "desc",
    sortField: "created_at",
  }
) => {
  try {
    const checkQuery = `?searchQuery=${functionally.searchQuery}&sortOrder=${functionally.sortOrder}&sortField=${functionally.sortField}&limit=${functionally.limit}&page=${functionally.page}&device_type=web`;
    const response = await API.get(
      `${CUSTOMER_NOTIFICATIONS.GET_NOTIFICATIONS_LIST}/${checkQuery}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  }
};
